import ProceedRoutes from "@/routes/providers/ProceedRoutes"
import LendingClubRoutes from "@/routes/providers/LendingClubRoutes"
import SynchronyRoutes from "@/routes/providers/SynchronyRoutes"
import HfdRoutes from "@/routes/providers/HfdRoutes"
import ClarityRoutes from "@/routes/providers/ClarityPayRoutes"

export default [
    ...apply(ProceedRoutes).routes,
    ...apply(LendingClubRoutes).routes,
    ...apply(SynchronyRoutes).routes,
    ...apply(HfdRoutes).routes,
    ...apply(ClarityRoutes).routes
]

function apply(routeConfig) {
    if (!routeConfig.providerKey) throw new Error("Provider Route config is missing a provider key.")
    if (!routeConfig.routes) throw new Error(`Route config for [${routeConfig.providerKey}] is missing a routes property.`)

    routeConfig.routes.forEach(route => {
        if (route.path?.includes(":providerKey")) {
            throw new Error(`Route [${route.path}] in config [${route.providerKey}] must not contain :providerKey because it's too generic`)
        }

        if (typeof route.redirect === 'string') {
            const path = route.redirect
            route.redirect = to => {
                to.params.providerKey = routeConfig.providerKey
                return {
                    path,
                }
            }
        }
    })

    return routeConfig
}
